import React from 'react';
import { Box, Typography } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  iconOnly?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ size = 'medium', showText = true, iconOnly = false }) => {
  const iconSize = size === 'small' ? 32 : size === 'large' ? 64 : 48;
  const fontSize = size === 'small' ? 20 : size === 'large' ? 48 : 32;

  return (
    <Box display="flex" alignItems="center" gap={iconOnly ? 0 : 1.5}>
      {/* Icon Character */}
      <Box
        sx={{
          width: iconSize,
          height: iconSize,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id={`brandGradient-${size}`} x1="0" y1="0" x2="512" y2="512" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="50%" stopColor="#764ba2" />
              <stop offset="100%" stopColor="#f093fb" />
            </linearGradient>
          </defs>

          {/* Background Shape */}
          <rect x="32" y="32" width="448" height="448" rx="120" fill={`url(#brandGradient-${size})`} />

          {/* Robot Character */}
          <g transform="translate(106, 116)">
            {/* Head/Face */}
            <rect x="0" y="40" width="300" height="240" rx="60" fill="white" />
            
            {/* Antenna */}
            <line x1="150" y1="40" x2="150" y2="0" stroke="white" strokeWidth="24" strokeLinecap="round" />
            <circle cx="150" cy="-20" r="24" fill="#f093fb" />

            {/* Eyes */}
            <ellipse cx="90" cy="140" rx="25" ry="35" fill="#764ba2" />
            <path d="M 185 140 L 235 140" stroke="#764ba2" strokeWidth="16" strokeLinecap="round" />
            
            {/* Blush Cheeks */}
            <circle cx="70" cy="180" r="15" fill="#f093fb" opacity="0.4" />
            <circle cx="230" cy="180" r="15" fill="#f093fb" opacity="0.4" />

            {/* Smile */}
            <path d="M 110 200 Q 150 230 190 200" stroke="#764ba2" strokeWidth="16" strokeLinecap="round" fill="none" />
          </g>
        </svg>
      </Box>

      {/* Text Brand */}
      {showText && !iconOnly && (
        <Typography
          variant="h4"
          sx={{
            fontSize: fontSize,
            fontWeight: 800,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '-0.02em',
            lineHeight: 1,
            display: { xs: size === 'large' ? 'none' : 'block', sm: 'block' },
          }}
        >
          ReachOut
        </Typography>
      )}
    </Box>
  );
};
